module.exports = __webpack_public_path__ + "img/DonikaLociBig.e9eb6f61.png";